import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";

// renders the basic input field
const GOIFieldDate = ({ disabled, value, inputData }) => {
  const { onInputValueChange } = useObjectInput();

  const { placeholder } = inputData.options;

  const handleValueChange = (e) => {
    let inputValue;
    inputValue = e.target.value;
    onInputValueChange(inputData.id, inputValue);
  };

  return (
    <input
      type="date"
      defaultValue={value}
      placeholder={placeholder}
      onChange={handleValueChange}
      disabled={disabled}
    />
  );
};

export default GOIFieldDate;
